import Vue from 'vue'
import axios from 'axios'
// import VueAxios from 'vue-axios'
// import qs from 'qs'
import Cookies from 'js-cookie';
import router from '../../router'
// import Message from 'element-ui';
// import store from '../../store'

// Vue.prototype.$qs = qs
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// Vue.use(VueAxios, axios)
const user = {
    state:{
        name:'',
        pwd:'',
        token: Cookies.get('Admin-Token'),
        errorTip:'',
        loginUser:{
            // user_id:'',
            // loginName:'',
            password:'',
            // user_role:'',
            is_new_user:Cookies.get('Admin-IsNewUser'),  //是否首次登陆
            // is_new_user:'1',
            tokenUser:Cookies.get('Admin-User'),    //用户角色

        },
        id:JSON.parse(localStorage.getItem("id")),//先去localStorage中获取数据
        permission:JSON.parse(localStorage.getItem("permission"))//先去localStorage中获取数据
    },
    mutations:{
        setId: (state, id) => {
            localStorage.setItem('id', JSON.stringify(id)); //将传递的数据先保存到localStorage中
            state.id = id;
        },
        setName: (state, name) => {
            state.name = name;   //记住密码时触发：用户名
        },
        setPwd: (state, pwd) => {
            state.pwd = pwd;   //记住密码时触发：密码
        },
        setToken: (state, token) => {
            state.token = token;
        },
        setTokenUser: (state, tokenUser) => {
            state.tokenRoles = tokenUser;
        },
        setError (state, errorDesc)
        {
            state.errorTip = errorDesc;
        },
        // setRoles (state, roles) {
        //     state.roles = roles;
        // },
        // setUserId:(state,user_id) => {
        //     state.loginUser.user_id = user_id;
        // },
        // setLoginName:(state,loginName) => {
        //     state.loginUser.loginName = loginName;
        // },
        setPassword:(state,password) => {
            state.loginUser.password = password;  //密码
        },
        // setUserRole:(state,user_role) => {
        //     state.loginUser.user_role = user_role;
        // },
        setIsNewUser:(state,is_new_user) => {
            state.loginUser.is_new_user = is_new_user;  //退出登录触发
        },
        setRoleId:(state,role_id) => {
            state.loginUser.role_id = role_id;   
        },
        setPermission:(state,permission) => {
            localStorage.setItem('permission', JSON.stringify(permission)); //将传递的数据先保存到localStorage中
            state.permission = permission;
        },
    },
    actions:{
        // 用户登录
        handleLogin({ commit,state})
        {
            commit('setError','');
            let regTip = '';
            // var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            //var regpwd = /^[\w]{6,16}$/;
            if(!state.name.replace(' ',''))
            {
                regTip = '请输入用户名/手机号/邮箱';
                commit('setError',regTip);
                return false;
            }
            if(!state.pwd.replace(' ',''))
            {
                regTip = '请输入密码';
                commit('setError',regTip);
                return false;
            }
            // if(!regpwd.test(state.pwd.replace(' ','')))
            // {
            //     regTip = '请输入6-16位密码';
            //     commit('setError',regTip);
            //     return false;
            // }
            let params = Vue.prototype.$qs.stringify({
                password:state.pwd.replace(' ',''),
                loginName:state.name.replace(' ','')
            })
            axios({
                method:'post',
                url:window.API_HOST+'/login/doLogin.do',
                data:params
            }).then((res)=>{
                let data = res.data;
                console.log(res.data.permissionsList)
                if(data.message.is_success == true) {
                    localStorage.loginname=data.user.loginName;
                    // localStorage.userid=data.user.userId;
                    localStorage.id=data.permissionsList[0].id;
                    localStorage.permission=data.permissionsList;
                    Cookies.set('Admin-Token', data.user.loginName);  //登录成功后将token存储在cookie之中
                    // Cookies.set('Admin-Token', data.permissionsList[0].id);
                    commit('setToken', data.user.loginName);
                    commit('setPassword',data.user.password);
                    commit('setName',data.user.loginName);
                    commit('setId',data.permissionsList[0].id);
                    commit('setRoleId',data.permissionsList.id);
                    commit('setPermission',data.permissionsList);
                    // commit('setPermission',data.permissionsList[0].name);
                    // let userPermission = data.permissionsList;
                    // console.log("data:"+data.permissionsList[0].id);
                    // console.log("PermissionsList:"+data.PermissionsList.length);
                        console.log(data.permissionsList);

                    for(var i = 0;i<data.permissionsList.length;i++){
                        console.log(data.permissionsList[i].name);

                    }

                    // router.addRoutes(permission)
                    //commit('setUser', data.user);  //用户的信息
                    router.push({path:'/'});
                }
                else
                {
                    alert('用户名或密码有误');
                    regTip = '用户名或密码错误';
                    commit('setError',regTip);
                }

            }).catch(function(){

            })
        },
        login({ commit,state})
        {
            commit('setError','');
            let regTip = '';
            // var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            //var regpwd = /^[\w]{6,16}$/;
            if(!state.name.replace(' ',''))
            {
                regTip = '请输入用户名/手机号/邮箱';
                commit('setError',regTip);
                return false;
            }
            if(!state.pwd.replace(' ',''))
            {
                regTip = '请输入密码';
                commit('setError',regTip);
                return false;
            }
            // if(!regpwd.test(state.pwd.replace(' ','')))
            // {
            //     regTip = '请输入6-16位密码';
            //     commit('setError',regTip);
            //     return false;
            // }
            let params = Vue.prototype.$qs.stringify({
                password:state.pwd.replace(' ',''),
                loginName:state.name.replace(' ','')
            })
            axios({
                method:'post',
                url:window.API_HOST+'/login/doLogin.do',
                data:params
            }).then((res)=>{
                let data = res.data;
                if(data.message.is_success == true) {
                    localStorage.loginname=data.user.loginName;
                    localStorage.userid=data.user.userId;
                    localStorage.id=data.permissionsList[0].id;
                    // localStorage.permission=data.permissionsList[0].name;
                    localStorage.permission=data.permissionsList;
                    Cookies.set('Admin-Token', data.user.loginName);
                    // Cookies.set('Admin-Token', data.permissionsList[0].id);
                    commit('setToken', data.user.loginName);
                    commit('setPassword',data.user.password);
                    commit('setName',data.user.loginName);
                    commit('setId',data.permissionsList[0].id);
                    commit('setRoleId',data.permissionsList.id);
                    // commit('setPermission',data.permissionsList[0].name);
                    commit('setPermission',data.permissionsList);
                    // let userPermission = data.permissionsList;
                    // console.log("data:"+data.permissionsList[0].id);
                    // console.log("PermissionsList:"+data.PermissionsList.length);
                    for(var i = 0;i<data.permissionsList.length;i++){
                        console.log(data.permissionsList[i].name);
                    }

                    //    router.addRoutes(permission);


                    //commit('setUser', data.user);  //用户的信息
                    router.push({path:'/'});
                }
                else
                {
                    alert('用户名或密码有误');
                    regTip = '用户名或密码错误';
                    commit('setError',regTip);
                }

            }).catch(function(){

            })
        },
        FedLogOut({ commit }) {
            axios({
                method:'post',
                url:window.API_HOST+'/login/logout.do',
            }).then((res)=>{
                let data = res.data;
                console.log(res.data)
                if(data.message.is_success == true)
                {
                    commit('setToken', '');
                    commit('setTokenUser', '');
                    commit('setIsNewUser', '');
                    commit('setName','');
                    commit('setPwd','');
                    Cookies.remove('Admin-Token');
                    localStorage.removeItem('loginname');
                    localStorage.removeItem('userid');
                    router.push({ path: '/login' })
                }
                else
                {
                    this.$alert(data.message.msg, '错误信息', {
                        confirmButtonText: '确定',
                        callback: action => {
                            console.log(`action: ${ action }`)
                        }
                    });
                    // commit('setError',data.message.msg);
                }

            }).catch(function(){

            })
        },
    }
}
export default user;
